import React from 'react';
import { observer } from 'mobx-react';

import Label from './Label';
import OuterCircle from './OuterCircle';
import InnerCircle from './InnerCircle';
import RadioInput from './RadioInput';

export default observer(({ className, isChosen, name, value, onChange }) => (
  <Label className={className} isChosen={isChosen}>
    <OuterCircle>
      <InnerCircle />
    </OuterCircle>
    <RadioInput name={name} onChange={() => onChange(value)} value={value} />
  </Label>
));
